import { PullToRefresh } from 'components/PullToRefresh/Base';
import { usePullToRefreshQuery } from 'components/PullToRefresh/hooks/usePullToRefreshQuery';
import React from 'react';
import { GraphQLTaggedNode, Variables } from 'utils/graphClient';

interface RelayPullToRefreshProps {
  queryRef: {
    query: GraphQLTaggedNode;
    variables: Variables;
  };
  children: JSX.Element;
}

export const RelayPullToRefresh: React.FC<RelayPullToRefreshProps> = ({
  queryRef,
  children,
}) => {
  const { query, variables } = queryRef;
  const { refresh, isRefreshing } = usePullToRefreshQuery(query, variables);

  return (
    <PullToRefresh isRefreshing={isRefreshing} onRefresh={refresh}>
      {children}
    </PullToRefresh>
  );
};
